import script from "./MenuItems.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuItems.vue?vue&type=script&setup=true&lang=ts"

import "./MenuItems.vue?vue&type=style&index=0&id=f5361dbe&lang=scss"

const __exports__ = script;

export default __exports__